// extracted by mini-css-extract-plugin
module.exports = {"container":"OldTitle_container__1ca9v","title":"OldTitle_title__146dw"};